module.exports = __webpack_public_path__ + "static/magglass-c5fc2b1f048cc69b1f09f46626ffa302.svg";